export default {
  namespaced: true,
  state: {
    isNewNotificationsOpen: false,
    unreadNotificationsCount: 0,
  },
  mutations: {
    SET_NEW_NOTIFICATIONS_OPEN(state, isOpen) {
      state.isNewNotificationsOpen = isOpen;
    },
    SET_UNREAD_NOTIFICATIONS_COUNT(state, unreadNotificationsCount) {
      state.unreadNotificationsCount = unreadNotificationsCount;
    }
  },
  actions: {
    toggleNewNotifications({ commit, state }) {
      commit("SET_NEW_NOTIFICATIONS_OPEN", !state.isNewNotificationsOpen);
    },
    openNewNotificationsModal({ commit }) {
      commit("SET_NEW_NOTIFICATIONS_OPEN", true);
    },
    closeNewNotificationsModal({ commit }) {
      commit("SET_NEW_NOTIFICATIONS_OPEN", false);
    },
  },
};
